/**
 * @generated SignedSource<<0570f078bc1fa1d21f9a047b072d22e0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SaveResetViewSettingsButtonUI$data = {
  readonly canPublishViewConfig: boolean | null | undefined;
  readonly savedViewId: string | null | undefined;
  readonly " $fragmentType": "SaveResetViewSettingsButtonUI";
};
export type SaveResetViewSettingsButtonUI$key = {
  readonly " $data"?: SaveResetViewSettingsButtonUI$data;
  readonly " $fragmentSpreads": FragmentRefs<"SaveResetViewSettingsButtonUI">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "SaveResetViewSettingsButtonUI",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "canPublishViewConfig"
    },
    {
      "kind": "ScalarField",
      "name": "savedViewId"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "44bced43d9497db9cf04d9c08bdfeb4e";

export default node;
